import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { handleError, handleSuccess } from '../utils';
import './CompleteProfile.css';

function CompleteProfile() {
    const [profileData, setProfileData] = useState({
        gender: '',
        phone: '',
        telegram: ''
    });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setProfileData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!profileData.gender) {
            return handleError('Gender is required');
        }

        setLoading(true);

        try {
            const token = localStorage.getItem('token');
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/auth/complete-profile`,
                {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    },
                    body: JSON.stringify(profileData)
                }
            );

            const result = await response.json();

            if (result.success) {
                // ✅ Update token with new profile info
                localStorage.setItem('token', result.jwtToken);
                if (result.user.gender) {
                    localStorage.setItem('gender', result.user.gender);
                }
                
                handleSuccess('Profile completed successfully!');
                setTimeout(() => navigate('/home'), 1000);
            } else {
                handleError(result.message || 'Failed to complete profile');
            }
        } catch (err) {
            console.error('Error:', err);
            handleError('Error completing profile');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="ui-page">
            <div className="ui-container">
                <div className="ui-header">
                    <div>
                        <h1 className="ui-title">Complete your profile</h1>
                        <p className="ui-subtitle">A few details help match you safely and effectively.</p>
                    </div>
                </div>

                <div className="ui-grid ui-grid-2" style={{ alignItems: 'start' }}>
                    <div className="ui-card">
                        <div className="ui-card-body">
                            <div className="ui-card-title">Why we ask</div>
                            <p className="ui-subtitle" style={{ marginTop: 0 }}>
                                This information enables safety features and helps ride partners contact you.
                            </p>
                            <div className="ui-divider" />
                            <ul className="ui-list">
                                <li>Select your gender for safety features</li>
                                <li>Add contact info for ride partners to reach you</li>
                                <li>Use Telegram for private messaging</li>
                            </ul>
                        </div>
                    </div>

                    <div className="ui-card">
                        <div className="ui-card-body">
                            <div className="ui-card-title">Your details</div>

                            <form onSubmit={handleSubmit} className="ui-stack" style={{ gap: '0.9rem' }}>
                                <div className="ui-field">
                                    <label className="ui-label" htmlFor='gender'>
                                        Gender <span style={{ color: '#b91c1c' }}>*</span>
                                    </label>
                                    <select
                                        id='gender'
                                        name='gender'
                                        value={profileData.gender}
                                        onChange={handleChange}
                                        required
                                        className="ui-select"
                                    >
                                        <option value=''>Select Gender</option>
                                        <option value='Male'>Male</option>
                                        <option value='Female'>Female</option>
                                        <option value='Other'>Other</option>
                                    </select>
                                </div>

                                <div className="ui-field">
                                    <label className="ui-label" htmlFor='phone'>Phone number (optional)</label>
                                    <input
                                        type='tel'
                                        id='phone'
                                        name='phone'
                                        value={profileData.phone}
                                        onChange={handleChange}
                                        placeholder='e.g. +91 9876543210'
                                        className="ui-input"
                                    />
                                    <p className="ui-help">Ride partners can contact you directly.</p>
                                </div>

                                <div className="ui-field">
                                    <label className="ui-label" htmlFor='telegram'>Telegram username (optional)</label>
                                    <input
                                        type='text'
                                        id='telegram'
                                        name='telegram'
                                        value={profileData.telegram}
                                        onChange={handleChange}
                                        placeholder='e.g. johndoe123'
                                        className="ui-input"
                                    />
                                    <p className="ui-help">Message without sharing your phone number.</p>
                                </div>

                                <button
                                    type='submit'
                                    disabled={loading}
                                    className="ui-btn ui-btn-primary ui-btn-block"
                                >
                                    {loading ? 'Saving…' : 'Continue to Home'}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    );
}

export default CompleteProfile;
